import { takeLatest, call, put } from 'redux-saga/effects'

import I18n from 'i18n'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import { ActionWithPayload } from 'helpers/redux-actions.helper'
import * as fromActions from 'store/actions/courses.action'
import UploadFile from '../../../api/commons/UploadFile'

const coursesMassiveUpload = (file: File) => {
  return UploadFile(file, `/imports/massive`)
}

const pattern = fromActions.COURSES_UPLOAD_MASSIVE_PARTICIPANTS

function* coursesUploadMassiveParticipantsEffectSaga(
  action: ActionWithPayload<typeof pattern, fromActions.UploadFilePayload>
) {
  try {
    const { file } = action.payload
    const { data } = yield call(coursesMassiveUpload, file)

    // dispatch action to change redux state
    yield put(fromActions.Actions.uploadMassiveParticipantsSuccess(data))

    try {
      if (data)
        yield put(
          fromActions.Actions.courseAdministrationGetList({
            page: 1,
            searchText: '',
            sort: [],
          })
        )
    } catch {
      // ignore
    }
  } catch (error) {
    yield put(fromActions.Actions.setCourseLoading(false))
    ErrorToast(I18n.t('administration.toastMessages.deleteError'))
    console.log('error: ', error)
  }
}

export function* coursesUploadMassiveParticipantsWatcherSaga() {
  yield takeLatest(
    fromActions.COURSES_UPLOAD_MASSIVE_PARTICIPANTS,
    coursesUploadMassiveParticipantsEffectSaga
  )
}
